import React from "react";
import HeaderSlider from "../../components/HeaderSlider/index";
import Product from "../../components/products/index";
import connect from "./connect";
import NewDesigner from "../NewDesigner/index";
import Footer from "../../components/footer/index";
import NewArrivals from "../../components/products/NewArrivals";
import FormContainer from "../../components/DesignerComponents/OrderForm/container";




class HomePage extends React.Component {

  render() {
    return (
      <div className="super_container_inner">
        <div className="super_overlay"></div>
        <div className="home">
          <HeaderSlider props={this.props} />
                    <div className="container">
              <div className="row">
                <div className="col-lg-6 offset-lg-3">
                  <div className="section_title text-center">
                    Start Designing From Here 
                  </div>
                </div>
              </div>
          <div id="designerDiv" className="row-fluid fill_height ">
            <NewDesigner newArrivals={this.props.homePage.newArrivals}/>
          </div>

            </div>

          <div className="products">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 offset-lg-3">
                  <div className="section_title text-center">
                    Our Beloved Customers Designs
                  </div>
                </div>
              </div>
                <Product props={this.props}/>
                {/* <NewArrivals props={this.props}/> */}
            </div>
          </div>
                    </div>


        </div>
    );
  }
}

export default connect(HomePage);
